export default __webpack_public_path__ + "static/PEPERIUMCLASSIC-0e93d5909505fd817c1fad3b167e3393.jpg";